import { render, staticRenderFns } from "./AttrList.vue?vue&type=template&id=3d3321ae&scoped=true&"
import script from "./AttrList.vue?vue&type=script&lang=js&"
export * from "./AttrList.vue?vue&type=script&lang=js&"
import style0 from "./AttrList.vue?vue&type=style&index=0&id=3d3321ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3321ae",
  null
  
)

export default component.exports